import { ReactElement, ReactNode } from "react"
import { useParams } from "react-router-dom"

import AmendAcuDeviceProvider from "./baseProviders/amendAcuDeviceProvider"
import useContinueAcuDeviceDraft from "../../../../../services/middleware/hooks/devices/lct/useContinueAcuDeviceDraft"

interface IContinueAcuDeviceAmendmentUrlParams {
    deviceRef: string
}

interface IContinueAcuDeviceAmendmentProviderProps {
    children: ReactNode
}

const ContinueAcuDeviceAmendmentProvider = ({
    children,
}: IContinueAcuDeviceAmendmentProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof IContinueAcuDeviceAmendmentUrlParams
    >() as IContinueAcuDeviceAmendmentUrlParams

    const {
        data: formData,
        setData: setFormData,
        isLoading,
        error: continueAmendmentError,
        attachmentUUID,
        apiResSystemRef,
    } = useContinueAcuDeviceDraft(urlDeviceRef)

    return (
        <AmendAcuDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={continueAmendmentError}
            attachmentUUID={attachmentUUID ?? undefined}
            systemReference={apiResSystemRef ?? "Not loaded"}
        >
            {children}
        </AmendAcuDeviceProvider>
    )
}

export default ContinueAcuDeviceAmendmentProvider
